import withFireUiAnalytics from '@atlassian/jira-analytics-web-react/src/components/with-fire-ui-analytics.tsx';
import ShareeTypePicker from './view.tsx';

export default withFireUiAnalytics({ onChange: 'pickShareeType' })(ShareeTypePicker);
export const EditorTypePicker = withFireUiAnalytics({ onChange: 'pickEditorType' })(
	ShareeTypePicker,
);
